import { createAction } from '@reduxjs/toolkit';

// Event Action of type Track
/* `const googleAdsEvent = createAction('googleAds/event');` is creating an action creator 
function using the `createAction` function from the `@reduxjs/toolkit` library. This action creator function will
return an action object with a `type` property set to `'googleAds/event'` when it is called. This
action can then be dispatched to the Redux store to trigger a state update or other side effects. */
const googleAdsEvent = createAction('googleAds/event');

export default googleAdsEvent;
